/**
 * Has OCR Data Guard
 *
 * Guard that checks if we have OCR data from ID scanning.
 */

import type { GuardWithMetadata } from "./sms.guard";

/**
 * Has OCR Data Guard
 *
 * Checks if we have successful OCR data from ID scanning OR
 * if the patient indicated they have a physical ID.
 *
 * Used to determine if we should show "confirm" vs "enter" copy.
 */
export const hasOcrData: GuardWithMetadata = {
  // biome-ignore lint/suspicious/noExplicitAny: XState guard params are complex
  impl: ({ context }: { context: any }) => {
    const hasOcrSuccess = !!(context.ocrId as { success?: boolean })?.success;
    const hasPhysicalId = !!(context.hasPhysicalId as boolean);

    return hasOcrSuccess || hasPhysicalId;
  },
  metadata: {
    displayName: "hasOcrData",
    description: "Has OCR data from ID scan or physical ID present",
    requiresContext: ["ocrId", "hasPhysicalId"],
    category: "context",
  },
};
